import {
  NodePreloadRulePayload,
  PreloaderRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { NodeType } from 'common/builder/constants/NodeType'
import { INode } from 'common/builder/nodes/nodeInterfaces'
import { initializeAvailableFields } from 'common/fields/linking/accountAvailableFields'
import * as segmentsActions from 'common/filter/actions/segmentsActions'
import { FilterScenario } from 'common/filter/interfaces'

export const ConditionGenericNodePreloadRule: PreloaderRule<INode, NodePreloadRulePayload> = {
  predicate: (entity: INode) => entity?.nodeType === NodeType.CONDITION,

  getKey: () => 'condition_node_data',

  createLoader:
    (_, { dispatch }) =>
    async () => {
      try {
        const promises: Array<Promise<unknown> | void> = [
          dispatch(initializeAvailableFields({ scenario: FilterScenario.CONDITION_NODE })),
        ]

        const result = dispatch(segmentsActions.fetchSegments())

        /**
         * Support for the flow charr player page
         * main/src/apps/flowPlayer/pages/FlowPlayer.page.js:108
         * As dispatch could be not a Promise
         */
        if (result instanceof Promise) {
          promises.push(result)
        }

        await Promise.all(promises)

        /**
         * Due to internal implementation of segmentsActions.fetchSegments
         * we cannot receive information about is call successfull or not.
         * In this case we are returning true in case action not firing any errors.
         */
        return true
      } catch (error) {
        return false
      }
    },
}
